// BotBubble.jsx
import React from "react";

// BotChatMessage.jsx
const BotBubble = ({ message, children}) => {
  // The lib will pass the text as `message`. `children` is a safe fallback.
  const content = message ?? children;

  return (
    <div className="relative ml-[12.5px] w-fit max-w-full text-[16px] bg-[#d3d3d3] text-[#404040] px-3 py-2 rounded-md">
      {content}
      {/* arrow */}
      <div className="absolute left-[-8px] top-1/2 -translate-y-1/2
                      border-y-[8px] border-y-transparent
                      border-r-[8px] border-r-[#d3d3d3]" />
    </div>
  );
}

export default BotBubble;